export default __webpack_public_path__ + "static/media/bdedu.e64c644e.PNG";